import PropTypes from 'prop-types'
import { useState } from 'react'
import { UseI18n } from '../hooks/useI18n'
import { Element } from '../html/element'
import { GROUP_CLASS_NAME, panelTypes } from './constants'
import classes from './index.module.scss'
import { PanelHeader } from './PanelHeader'

export const Panel = ({
  children,
  isI18n,
  label,
  renderLabel,
  style,
  type,
  id,
  changeLayout,
  isAllowDragDrop,
  height,
  renderRightHeader,
  headerStyle,
  downloadJpgParams,
  downloadCsv,
  className,
}) => {
  const [isShowIconDrag, setIsShowIconDrag] = useState(false)

  const formatLabel = isI18n ? UseI18n(label) : label

  const onDragOver = (e) => {
    e.preventDefault()
    e.stopPropagation()
  }

  const onDragStart = (e) => {
    const imageDragEl = e.target.cloneNode(true)
    e.dataTransfer.setDragImage(imageDragEl, e.target.offsetWidth / 2, 20)
    e.dataTransfer.setData('childId', e.target.id)
  }

  const onMouseEnter = () => {
    if (isAllowDragDrop) {
      setIsShowIconDrag(true)
    }
  }

  const onMouseLeave = () => {
    if (isAllowDragDrop) {
      setIsShowIconDrag(false)
    }
  }

  const renderHeader = () => {
    return (
      <PanelHeader
        label={formatLabel}
        renderLabel={renderLabel}
        changeLayout={changeLayout}
        isAllowDragDrop={isAllowDragDrop}
        renderRightHeader={renderRightHeader}
        headerStyle={headerStyle}
        downloadJpgParams={downloadJpgParams}
        downloadCsv={downloadCsv}
        isShowIconDrag={isShowIconDrag}
      />
    )
  }

  return (
    <Element
      id={id}
      type={type}
      label={formatLabel}
      className={[className, classes.container, GROUP_CLASS_NAME].join(' ')}
      style={{
        borderColor: '#D5D5D5',
        width:
          type === panelTypes.FULL_SIZE
            ? 'calc(100% - 12px)'
            : 'calc(50% - 12px)',
        height: height || 'auto',
        ...style,
      }}
      draggable={isAllowDragDrop}
      onDragStart={onDragStart}
      onDragOver={onDragOver}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
    >
      {renderHeader()}
      <div className="flex1 minH0">{children}</div>
    </Element>
  )
}

Panel.propTypes = {
  children: PropTypes.node.isRequired,
  id: PropTypes.string,
  isI18n: PropTypes.bool,
  label: PropTypes.string,
  renderLabel: PropTypes.func,
  style: PropTypes.object,
  type: PropTypes.string,
  changeLayout: PropTypes.func,
  isAllowDragDrop: PropTypes.bool,
  height: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  renderRightHeader: PropTypes.func,
  headerStyle: PropTypes.object,
  downloadJpgParams: PropTypes.shape({
    domId: PropTypes.string,
    arrName: PropTypes.array.isRequired,
    titleJpg: PropTypes.string,
    DownloadComponent: PropTypes.node,
    disabled: PropTypes.bool,
  }),
  downloadCsv: PropTypes.shape({
    downloadFunc: PropTypes.func.isRequired,
    disabled: PropTypes.bool,
  }),
  className: PropTypes.string,
}

Panel.defaultProps = {
  isI18n: false,
  label: '',
  iconToolTipLabel: false,
  style: {},
  headerStyle: {},
  type: panelTypes.FULL_SIZE,
  changeLayout: () => {},
  isAllowDragDrop: false,
  className: '',
}
